import { faCheck, faCheckCircle, faXmark, faXmarkCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Spinner, Table } from 'react-bootstrap'
import VerifiedUserModal from '../modals/VerifiedUser.modal'
import { faEye } from '@fortawesome/free-regular-svg-icons'
import UserModal from '../modals/User.modal'
import { table } from 'console'

interface IFilterTable {
    tableData: any
    shiftId: any
}

const FilterTable = ({ tableData,shiftId }: IFilterTable) => {

    const [showModal, setShowModal] = useState<any>(undefined);

    const [showUserModal, setShowUserModal] = useState<any>(undefined)

    function isUserVerified(user: any) {
        const details = tableData?.find((verified: any) => verified?._id === user?._id);
        if (!details) {
            return false;
        }

        return details.verificationDetails.some((verification: any) => verification.verificationDetails.some((ver: any) => ver.success === true || ver.manuallyVerified === true));
    }


    return (
        <>

            <Table striped  hover size="sm">
                <thead>
                    <tr>
                        <th style = {{fontSize: 14}}>Sr.No</th>
                        <th style = {{fontSize: 14}}>Candidate Name</th>
                        {/* <th>Photo</th> */}
                        <th style = {{fontSize: 14}}>Roll.No</th>
                        <th style = {{fontSize: 14}}>Verification</th>
                        <th style = {{fontSize: 14}}>Exam</th>
                        {/* <th>Mobile</th> */}
                        <th style = {{fontSize: 14}}>State</th>
                        <th style = {{fontSize: 14}}>Division</th>
                        <th style = {{fontSize: 14}}>District</th>
                        <th style = {{fontSize: 14}}>Venue Name / Venue ID</th>
                        <th style = {{fontSize: 14}}></th>
                    </tr>
                </thead>
                <tbody>
                    {tableData && tableData.length > 0 ? (
                        tableData.map((data: any, index: number) => {
                            const verifiedUser = tableData?.verifications?.find((verified: any) => verified?.student?._id === data?._id);
                            return (
                                <tr key={data?._id || index}>
                                    <td style = {{fontSize: 12}}>{index + 1}</td>
                                    <td style = {{fontSize: 12}}>{data?.name || "--"}</td>
                                    <td style = {{fontSize: 12}}>{data?.rollNo || "--"}</td>
                                    <td style = {{fontSize: 12}}>
                                        {isUserVerified(data) ? (
                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                                        ) : (
                                            <FontAwesomeIcon icon={faXmarkCircle} className="text-danger" />
                                        )}
                                    </td>
                                    <td style = {{fontSize: 12}}>{data?.courseName || "--"}</td>
                                    <td style = {{fontSize: 12}}>{data?.state || "--"}</td>
                                    <td style = {{fontSize: 12}}>{data?.zone || "--"}</td>
                                    <td style = {{fontSize: 12}}>{data?.city || "--"}</td>
                                    <td style = {{fontSize: 12}}> <b className='text-success'>{data.allocatedCenterId || "--"}</b> - {data?.centerPreference|| "--"}</td>
                                    <td style = {{fontSize: 12}}>
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className="text-primary"
                                            onClick={() => setShowUserModal(data._id)}
                                        />
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={7} className="text-center">
                                <span>No data found</span>
                            </td>
                        </tr>
                    )}
                </tbody>

            </Table>

            <VerifiedUserModal
                show={showModal ? true : false}
                handleClose={() => setShowModal(undefined)}
                modalData={
                    tableData && tableData?.verifications?.find((verified: any) => verified?.studentId === showModal)
                }
            />

            <UserModal
                show={showUserModal}
                handleClose={() => setShowUserModal(undefined)}
                shiftId={shiftId}
            />
        </>
    )
}

export default FilterTable